import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UtilService } from 'src/app/core/services/util.service';
import { ColorPickerCardComponent } from '../../util/colors/color-picker-card/color-picker-card.component';
import { ColorPickerCardOptions } from '../../util/colors/color-picker-card/color-picker-card.model';

@Component({
  selector: 'gio-custom-color',
  templateUrl: './custom-color.component.html',
  styleUrls: ['./custom-color.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CustomColorComponent
    }
  ]
})
export class CustomColorComponent implements OnInit, ControlValueAccessor, OnChanges {

  @Input()
  options: ColorPickerCardOptions;

  @Input()
  position: 'top' | 'bottom' | 'popup' | 'auto' = 'bottom';

  @Input()
  align: 'left' | 'center' | 'right' = 'left';


  _position: 'top' | 'bottom' | 'popup' = 'bottom';
  _align: 'left' | 'center' | 'right' = 'left';


  color: string;
  onChange = (colo: string) => { };
  onTouched = () => { };
  touched = false;
  disabled = false;

  showPicker = false;

  styles = {
    picker: {}
  }

  constructor(
    private util: UtilService,
    private modal: MatDialog
  ) { }

  ngOnInit() {
    this.calculatePickerPosition();
  }
  ngOnChanges() {
    this.calculatePickerPosition();
  }

  private calculatePickerPosition() {
    const width = this.util.responsive.width;
    let x = '0';
    let y = '0';


    this._position = this.position == 'auto' ? (width < 450 ? 'popup' : 'top') : this.position;
    this._align = this.align;

    if (this._position == 'popup') {
      return;
    } else if (this._position == 'bottom') {

    } else if (this._position == 'top') {
      y = 'calc(-100% - 34px)';
    }

    if (this.align == 'right') {
      x = '-100%';
    } else if (this.align == 'center') {
      x = '-50%';
    } else if (this.align == 'left') {
      x = '0'
    }

    this.styles.picker = {
      position: 'fixed',
      transform: `translate(${x}, ${y})`,
      zIndex: '300'
    }

  }

  writeValue(color: string) {
    this.color = color;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  colorChangedOnPicker(color?: string) {
    this.changeColor(color);
  }

  async colorClicked() {
    if (this.disabled) {
      this.showPicker = false;
      return;
    }

    if (this._position == 'popup') {
      const ref = this.modal.open(ColorPickerCardComponent, {
        panelClass: 'no-padding',
        closeOnNavigation: true,
        disableClose: true,
        maxWidth: '95vw',
        maxHeight: '95vw',
        data: {
          color: this.color,
          options: this.options
        }
      });

      ref.afterClosed().subscribe(this.changeColor.bind(this))
      return;
    }

    this.showPicker = !this.showPicker;
  }

  async changeColor(color: string) {
    this.color = color;
    this.onChange(this.color);
  }
}
